import { styled, Tab } from "@mui/material"

export const StyledMetricTab = styled(Tab)`
  margin-top: 8px;
  margin-right: 15px;
  border: none;
  height: 7vh;
  background: #1c56ce 0% 0% no-repeat padding-box;
  border-radius: 4px 4px 0px 0px;
  opacity: 1;
  color: #fff;
  flex-grow: 1;
`
